import React, { Component } from "react";
import { Link } from "react-router-dom";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

import Logo from "../../design/img/yaystack-logo.png";

let strings = new LocalizedStrings({ en });

class SignInSignUp extends Component {
  state = {};
  render() {
    return (
      <div className="profilePage welcomePage center">
        <div className="welcome">
          <div>{strings.welcome}</div>
          <img className="max_width_300 mt-2" src={Logo} alt="Yaystack Logo" />
          <div className="center button_sign">
            <div className="max_width_300">
              <Link to="/sign_in">
                <button className="btn btn_primary btn_yaystack mb-4 width_100">
                  {strings.sign_in}
                </button>
              </Link>
              <br />
              <Link to="/sign_up">
                <button className="btn btn_primary btn_yaystack width_100">
                  {strings.sign_up}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SignInSignUp;



// WEBPACK FOOTER //
// ./src/components/profile/sign_in_sign_up.jsx